import { Chip, Avatar, ChipProps, useTheme, lighten } from "@mui/material";
import { useState } from "react";
import SyncAltIcon from "@mui/icons-material/SyncAlt";

interface HTChipProps extends ChipProps {
  code?: string;
  chipColor?: string;
  label2?: string;
}

const HTChip = ({ code, icon, chipColor, label, label2, className, disabled, sx, onDelete, deleteIcon, onClick, ...others }: HTChipProps) => {
  const [label2Active, setLabel2Active] = useState(false);
  const theme = useTheme();
  const color = disabled ? lighten(chipColor || theme.palette.text.primary, 0.5) : chipColor || theme.palette.text.primary;

  return (
    <Chip
      avatar={code ? <Avatar>{code}</Avatar> : undefined}
      icon={!code ? icon : undefined}
      variant="outlined"
      sx={{
        // borderColor: color,
        // marginLeft: 0.5,
        ".MuiChip-avatar": {
        //   fontSize: "0.7rem",
        //   paddingTop: "1px",
        //   margin: 0,
        //   marginLeft: -0.5,
        //   width: 32,
        //   height: 32,
          backgroundColor: color,
          color: theme.palette.getContrastText(color),
        },
        ...sx,
      }}
      className={className + (disabled ? " disabledrow" : "")}
      label={label2Active ? label2 || label : label}
      onClick={onClick ? onClick : label2 && label ? () => setLabel2Active((old) => !old) : undefined}
      deleteIcon={deleteIcon ? deleteIcon : !onDelete && label2 && label ? <SyncAltIcon /> : undefined}
      onDelete={onDelete ? onDelete : !onDelete && label2 && label ? () => setLabel2Active((old) => !old) : undefined}
      {...others}
    />
  );
};

export default HTChip;
